import {PublicKey} from './publickey';

export const SYSVAR_CLOCK_PUBKEY = new PublicKey(
  'SysvarC1ock11111111111111111111111111111111',
);

export const SYSVAR_RECENT_BLOCKHASHES_PUBKEY = new PublicKey(
  'SysvarRecentB1ockHashes11111111111111111111',
);

export const SYSVAR_RENT_PUBKEY = new PublicKey(
  'SysvarRent111111111111111111111111111111111',
);

export const SYSVAR_REWARDS_PUBKEY = new PublicKey(
  'SysvarRewards111111111111111111111111111111',
);

export const SYSVAR_STAKE_HISTORY_PUBKEY = new PublicKey(
  'SysvarStakeHistory1111111111111111111111111',
);

export const SYSVAR_INSTRUCTIONS_PUBKEY = new PublicKey(
  'Sysvar1nstructions1111111111111111111111111',
);
